import { render } from "./Bullfight.vue?vue&type=template&id=be8f04c8"
import script from "./Bullfight.vue?vue&type=script&lang=js"
export * from "./Bullfight.vue?vue&type=script&lang=js"

import "./Bullfight.vue?vue&type=style&index=0&id=be8f04c8&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__